// extracted by mini-css-extract-plugin
export default {"searchbox":"recordHistoryList_searchbox__jKzVt","date":"recordHistoryList_date__MNKfw","total":"recordHistoryList_total__F1pRr"};